export default __webpack_public_path__ + "static/media/english-to-polish-screenshot-03.c63251b6.png";